<!--企微裂变相关-->
<template>
  <div class="detail1">
    <!--基本设置-->
    <div class="form-region">
      <div class="form-region-title"><span>基本设置</span></div>
      <div class="form-region-row" v-show="false">
        <span class="title">内部名称</span>
        <input
          class="input"
          type="text"
          v-model="item.coupon_title"
          maxlength="20"
          placeholder="对内展示的活动名称"
        />
      </div>
      <div class="form-region-row">
        <span class="title">活动名称</span>
        <input
          class="input"
          type="text"
          v-model="item.pub_title"
          maxlength="20"
          placeholder="对外展示的活动名称"
        />
      </div>
      <div class="form-region-row pointer" @click="seltime(1)">
        <span class="title">活动开始时间</span>
        <input
          class="input"
          type="text"
          maxlength="20"
          readonly
          :value="item.coupon_begindate"
          placeholder="点击选择"
        />
        <van-icon name="arrow" />
      </div>
      <div class="form-region-row pointer" @click="seltime(2)">
        <span class="title">活动结束时间</span>
        <input
          class="input"
          type="text"
          maxlength="20"
          readonly
          :value="item.coupon_expdate"
          placeholder="点击选择"
        />
        <van-icon name="arrow" />
      </div>
      <div class="form-region-row pointer" @click="textEvent('rule')">
        <span class="title">活动规则介绍</span>
        <input
          class="input"
          type="text"
          maxlength="20"
          :value="item_giftrule"
          readonly
          placeholder="显示在排行榜的规则介绍"
        />
        <van-icon name="arrow" />
      </div>
    </div>
    <!--添加企业微信好友设置-->
    <div class="form-region pointer">
      <div class="form-region-title"><span>添加企业微信好友设置</span></div>
      <div class="form-region-row pointer" @click="seluseuserEvent">
        <span class="title">添加的企微号</span>
        <template v-if="!useuser.loading">
          <div class="input"></div>
          <van-loading size="18px" />
        </template>
        <template v-else>
          <div class="input" v-if="getUserName.length <= 0">
            活动添加的企微号，可多选
          </div>
          <div class="input tags" v-else>
            <div class="lqizi"></div>
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide
                class="tag"
                v-for="(user, index) in getUserName"
                :key="index"
                >{{ user }}</swiper-slide
              >
            </swiper>
          </div>
        </template>
        <van-icon name="arrow" />
      </div>

      <div class="form-region-row pointer" @click="editReward('addgift')">
        <span class="title">新添加好友奖励</span>
        <van-switch
          v-model="item.giftconfig.addgift.has"
          size="18px"
          @click.stop
        />
        <template v-if="item.giftconfig.addgift.has">
          <div
            style="color: #212121"
            class="input"
            v-if="
              item.giftconfig.addgift.content &&
              item.giftconfig.addgift.content.formid
            "
          >
            内容已经设置，点击修改
          </div>
          <div class="input" v-else>点击设置奖励的具体内容</div>
          <van-icon name="arrow" />
        </template>
      </div>
      <div class="form-region-row pointer" @click="showHiEdit">
        <span class="title">新添加好友欢迎语</span>
        <input
          class="input"
          type="text"
          maxlength="20"
          readonly
          :value="hi_content_text"
          placeholder="添加好友后自动回复的第一条信息"
        />
        <van-icon name="arrow" />
      </div>
      <div class="form-region-row pointer" @click="onSelectTags">
        <span class="title">自动打标签</span>
        <van-switch v-model="item.auto_tab" size="18px" @click.stop />
        <div class="input" v-if="item.auto_tab && getTabName.length <= 0">
          通过当前活动添加客户打上统一标签
        </div>
        <div class="input tags" v-else-if="item.auto_tab">
          <div class="lqizi"></div>
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide
              class="tag"
              v-for="(tab, index) in getTabName"
              :key="index"
              >{{ tab }}</swiper-slide
            >
          </swiper>
        </div>
        <van-icon name="arrow" v-if="item.auto_tab" />
      </div>
    </div>
    <!--裂变设置-->
    <div class="form-region">
      <div class="form-region-title">
        <span>裂变设置</span><van-switch v-model="item.h_share" size="28px" />
      </div>
      <div
        class="form-region-row pointer"
        v-if="item.h_share"
        @click="poseter_module"
      >
        <span class="title">海报设置</span>
        <div class="input" v-if="posterupload_result" style="color: #212121">
          海报已设置，点击修改
        </div>
        <div class="input" v-else>用户添加企微后会自动推送的裂变海报</div>
        <van-icon name="arrow" />
      </div>

      <div
        class="form-region-row pointer"
        v-if="item.h_share"
        @click="textEvent('share')"
      >
        <span class="title">裂变参考话术</span>
        <input
          class="input"
          type="text"
          maxlength="20"
          readonly
          :value="item_share_words"
          placeholder="老用户推荐用户的参考话术"
        />
        <van-icon name="arrow" />
      </div>

      <div
        class="form-region-row pointer"
        v-if="item.h_share"
        @click="startShareReward"
      >
        <span class="title">奖励设置</span>
        <div
          class="input"
          style="color: #212121"
          v-if="
            item.giftconfig.regift.content &&
            item.giftconfig.regift.content.length > 0
          "
        >
          已设置，点击可修改
        </div>
        <div class="input" v-else>推荐用户可获得的奖励设置</div>
        <van-icon name="arrow" />
      </div>
       <!-- 中奖评率提醒 -->
      <div class="form-region-row pointer" @click="frequencyClick()">
        <span class="title">提醒频率设置</span>
        <div v-if="remindconfig.frequency!=null" class="input">提醒频率为{{time.interval[remindconfig.frequency]}}</div>
        <div v-else class="input">设置中奖提醒的频率</div>

        <van-icon name="arrow" />
      </div>
    </div>
    <!--异常设置-->
    <div class="form-region">
      <div class="form-region-title">
        <span>异常设置</span>
      </div>
      <div class="form-region-row pointer" @click="setCatchConfig">
        <span class="title">活动结束回复</span>
        <div
          class="input"
          v-if="item.catchconfig.end && item.catchconfig.end.text"
          style="color: #212121"
        >
          已设置，点击修改
        </div>
        <div class="input" v-else>活动结束后再添加企微时自动发送的内容</div>
        <van-icon name="arrow" />
      </div>
    </div>
    <div class="form-bottom"></div>
    <div class="form-tool">
      <van-button
        type="info"
        block
        size="large"
        @click="subdata"
        :loading="loading_sub"
        >发布活动</van-button
      >
    </div>
    <van-popup v-model="vanttime_show" position="bottom">
      <van-datetime-picker
        v-model="nowDate"
        type="datetime"
        title="请选择时间"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="vanttime_confirm"
        @cancel="vanttime_cancel"
      />
    </van-popup>
    <van-popup
      v-model="userTabs_sel"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <wx_tags :userTabs="userTabs" v-if="userTabs_sel"></wx_tags>
    </van-popup>
    <van-popup
      v-model="useuser_sel"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <wx_users :useuser="useuser" v-if="useuser_sel && !hasdept"></wx_users>
      <wx_usersn :useuser="useuser" v-if="useuser_sel && hasdept"></wx_usersn>
    </van-popup>
    <van-popup
      v-model="text_show"
      position="right"
      :style="{ height: '100%', width: '100%' }"
    >
      <div class="logic-field-head">
        <a href="javascript:void(0);" class="fleft" @click="text_show = false"
          >取消</a
        >
        <a href="javascript:void(0);" class="fright" @click="logicFieldEnter"
          >确认</a
        >
      </div>
      <div class="logic-field-content">
        <van-field
          v-model="text_clone"
          :autosize="{ minHeight: 300, maxHeight: 800 }"
          type="textarea"
          :placeholder="text_placeholder"
        />
      </div>
    </van-popup>

    <van-popup
      v-model="hi_show"
      position="right"
      :style="{ height: '100%', width: '100%' }"
    >
      <div class="logic-field-head">
        <a href="javascript:void(0);" class="fleft" @click="hi_show = false"
          >取消</a
        >
        <a href="javascript:void(0);" class="fright" @click="hiShowEnter"
          >确认</a
        >
      </div>
      <div class="logic-field-content">
        <div_editable
          v-model="editHtml"
          class="edit-contain"
          style=""
          :id="'diveditable'"
          @blurFunc="blurHighLight"
          @logRange="logRange"
        ></div_editable>
        <div class="edit-var">
          <span @click="addval('用户昵称')">用户昵称</span>
          <span @click="addval('排行榜链接')">排行榜链接</span>
          <span @click="addval('分享文案')">分享文案</span>
          <span @click="addval('兑换奖品')">新添加好友奖励领取链接</span>
          <span @click="addval('我邀请的用户链接')">我邀请的用户链接</span>
          <span @click="addval('我的奖品链接')">我的奖品链接</span>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="posterupload_show" position="bottom">
      <div class="popup-menu">
        <div class="popup-menu-content"></div>
        <a
          href="javascript:void(0);"
          class="fright cancel"
          @click="posterupload_show = false"
          >取消</a
        >
      </div>
      <wx_poster
        @callback="poster_module_enter"
        v-if="posterupload_show"
      ></wx_poster>
    </van-popup>

    <van-popup
      v-model="reward.SettleShow"
      position="bottom"
      :style="{ height: '100%', width: '100%' }"
    >
      <lu_formedit
        v-if="reward.SettleShow"
        :formtype="3"
        :defaultfields="reward.rewardtype"
        v-model="reward.nowitem.content.formid"
        :cc="reward.editcc"
      ></lu_formedit>
    </van-popup>

    <van-popup
      v-model="reward.rewardTypeShow"
      round
      position="bottom"
      closeable
    >
      <lu_rewardtype :cc="reward.typecc"></lu_rewardtype>
    </van-popup>

    <van-popup
      v-model="reward.shareShow"
      position="bottom"
      :style="{ height: '100%', width: '100%' }"
    >
      <div class="logic-field-head">
        <a
          href="javascript:void(0);"
          class="fleft"
          @click="reward.shareShow = false"
          >取消</a
        >
        <a href="javascript:void(0);" class="fright" @click="enterShareReward"
          >确认</a
        >
      </div>
      <lu_rewardsettle
        :cc="reward.sharecc"
        v-model="reward.shareGift"
        v-if="reward.shareShow"
      ></lu_rewardsettle>
    </van-popup>

    <van-popup
      v-model="reward.SettleShow"
      position="bottom"
      :style="{ height: '100%', width: '100%' }"
    >
      <div class="logic-field-head">
        <a
          href="javascript:void(0);"
          class="fleft"
          @click="reward.SettleShow = false"
          >取消</a
        >
        <a href="javascript:void(0);" class="fright" @click="enterReward"
          >确认</a
        >
      </div>
      <lu_rewardsettleadd
        :cc="reward.cc"
        v-model="reward.nowitem.content"
        v-if="reward.SettleShow"
      ></lu_rewardsettleadd>
    </van-popup>

    <van-popup
      v-model="catchconfig.show"
      position="bottom"
      :style="{ width: '100%' }"
    >
      <div class="logic-field-head">
        <a href="javascript:void(0);" class="fright" @click="enterCatchConfig"
          >确认</a
        >
      </div>
      <div class="logic-field-content">
        <lu_qwautohi
          v-if="catchconfig.show"
          v-model="item.catchconfig.end"
        ></lu_qwautohi>
      </div>
    </van-popup>

    <!-- 中奖频率 -->
    <van-popup
      v-model="showFrequency"
      position="bottom"
      :style="{ height: '100%', width: '100%' }"
    >
      <div class="logic-field-head">
        <a
          href="javascript:void(0);"
          class="flight"
          @click="showFrequency = false"
          >取消</a
        >
        <a href="javascript:void(0);" class="fright" @click="timeClick">确认</a>
      </div>
      <div class="logic-field-content" v-if="remindconfig.frequency!=null">
        <van-field
          readonly
          clickable
          label="提醒频率"
          :value="time.interval[remindconfig.frequency]"
          placeholder="选择提醒频率"
          @click="time.showInterval = true"
        />
        间隔时间
        <van-popup v-model="time.showInterval" position="bottom">
          <van-picker
            title="提醒频率"
            show-toolbar
            :columns="time.interval"
            visible-item-count="3"
            @confirm="timeConfim"
            @cancel="timeCancel"
          />
        </van-popup>

        起止时间
        <van-field
          readonly
          clickable
          label="提醒开始时间"
          :value="remindconfig.timebegin==null?'':remindconfig.timebegin+ '点' "
          placeholder="开始时间"
          @click="time.beginShow = true"
        />
        <van-popup v-model="time.beginShow" position="bottom">
          <van-picker
            title="提醒开始时间"
            show-toolbar
            :columns="time.timeBeginList"
            visible-item-count="3"
            @confirm="beginConfim"
          />
        </van-popup>

        <van-field
          readonly
          clickable
          label="提醒结束时间"
          :value="remindconfig.timeend==null?'':remindconfig.timeend+'点' "
          placeholder="结束时间"
          @click="time.endShow = true"
        />
        <van-popup v-model="time.endShow" position="bottom">
          <van-picker
            title="提醒结束时间"
            show-toolbar
            :columns="time.timeEndList"
            visible-item-count="3"
            @confirm="endConfim"
          />
        </van-popup>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";

import config from "@/config";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
import lu_formedit from "../form/edit";
import lu_rewardtype from "./RewardType";
import lu_rewardsettle from "./RewardSettle";
import lu_rewardsettleadd from "./RewardSettleAdd";
import lu_qwautohi from "./QWAutoHi";
import wx_usersn from "../SelUserN";
import wx_users from "../SelUser";
import wx_tags from "../Tags";
import wx_poster from "../poster/posteredit";
import div_editable from "../../components/diveditable";
import { Dialog, Search, Switch, Field, Loading, Toast } from "vant";

import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";

Vue.use(Switch);
Vue.use(Search);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(Toast);

var lastEditRange;

function keepLastIndex(obj, newcontent) {
  console.log("obj", obj);
  console.log("window.getSelection", window.getSelection);
  console.log("document.selection", document.selection);
  var selection;

  if (window.getSelection) {
    //ie11 10 9 ff safari
    obj.focus(); //解决ff不获取焦点无法定位问题
    selection = window.getSelection(); //创建range
    console.log("lastEditRange", lastEditRange);
    if (!lastEditRange) {
      selection.selectAllChildren(obj); //range 选择obj下所有子内容
      selection.collapseToEnd(); //光标移至最后
    } else {
      selection.removeAllRanges();
      selection.addRange(lastEditRange);
    }
  } else if (document.selection) {
    //ie10 9 8 7 6 5
    selection = document.selection.createRange(); //创建选择对象
    //var range = document.body.createTextRange();
    selection.moveToElementText(obj); //range定位到obj
    selection.collapse(false); //光标移至最后
    selection.select();
  }
  var newNode = document.createElement("a");

  newNode.setAttribute(
    "btype",
    newcontent.replace(/新添加好友奖励领取链接/, "兑换奖品链接")
  );
  newNode.innerText = newcontent;
  var edit = document.getElementById("diveditable");
  // 判断选定对象范围是编辑框还是文本节点
  if (
    selection.anchorNode.nodeName != "#text" ||
    (selection.anchorNode.parentNode &&
      selection.anchorNode.parentNode.tagName == "A")
  ) {
    // 如果是编辑框范围。则创建表情文本节点进行插入
    if (edit.childNodes.length > 0) {
      // 如果文本框的子元素大于0，则表示有其他元素，则按照位置插入表情节点
      for (var i = 0; i < edit.childNodes.length; i++) {
        if (i == selection.anchorOffset) {
          edit.insertBefore(newNode, edit.childNodes[i]);
        }
      }
    } else {
      // 否则直接插入一个表情元素
      edit.appendChild(newNode);
    }
    // 创建新的光标对象
    var range = document.createRange();
    // 光标对象的范围界定为新建的表情节点
    range.selectNodeContents(newNode);
    // 光标位置定位在表情节点的最大长度
    range.setStart(newNode, newNode.length);
    // 使光标开始和光标结束重叠
    range.collapse(true);
    // 清除选定对象的所有光标对象
    selection.removeAllRanges();
    // 插入新的光标对象
    selection.addRange(range);
  } else {
    // 如果是文本节点则先获取光标对象
    var range = selection.getRangeAt(0);
    // 获取光标对象的范围界定对象，一般就是textNode对象
    var textNode = range.startContainer;
    // 获取光标位置
    var rangeStartOffset = range.startOffset;
    // 文本节点在光标位置处插入新的内容
    var newTextNode = textNode.splitText(rangeStartOffset);
    var parent = edit;
    if (textNode.parentNode.getAttribute("id") != diveditable)
      parent = textNode.parentNode;
    parent.insertBefore(newNode, newTextNode);
    range.setStart(newTextNode, 0);
    range.collapse(true);

    //添加a标签后自动移动光标到新的文本节点中
    if (newNode.tagName == "A") {
      var textNode = document.createTextNode(" ");
      range.insertNode(textNode);
      range.setStartAfter(textNode);
    }

    // 清除选定对象的所有光标对象
    selection.removeAllRanges();
    // 插入新的光标对象
    selection.addRange(range);
  }
  // 无论如何都要记录最后光标对象
  lastEditRange = selection.getRangeAt(0);

  return obj.innerHTML;
}

export default {
  name: "detail1",
  data() {
    return {
      catchconfig: {
        show: false,
      },
      corpinfo: null,
      loading_sub: false,
      reward: {
        SettleShow: false,
        form_code: "",
        cc: {
          close: function () {},
        },
        editcc: {
          close: function () {},
        },
        nowitem: {
          action: "",
          content: { formid: 0 },
        },
        rewardTypeShow: false,
        rewardtype: 1,
        typecc: {
          close: function () {},
        },

        shareShow: false,
        sharecc: {
          close: function () {},
        },
        shareGift: [],
      },
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },

        direction: "horizontal",
        slidesPerView: "auto",
        freeMode: true,

        mousewheel: true,
        // Some Swiper option/callback...
      },
      checked: false,
      item: {
        channelid: 0,
        channel_name: "",
        coupon_title: "好友裂变",
        pub_title: "",
        auto_gift: 0,
        gifttype: true,
        giftunit: true,
        giftcount: 0,
        giftdesc: "",
        remark: "",
        auto_firend: true,
        auto_sayhi: true,
        useuser: "",
        tab_content: [],
        hi_content: {
          text: {
            content:
              "嗨，你好呀，我是私域增长圈的负责人小潘，你的朋友花了99元为你购买了《3节私域增长线上课》，下方是课程的优惠券，你点击领取后即可0元兑换课程了哟~",
          },
          image: {
            media_path: "",
          },
          link: {
            title: "",
            picurl: "",
            desc: "",
            url: "",
          },
        },
        auto_tab: true,
        rank_rule: ``,
        share_words: ``,
        err_text: ``,
        giftrule: ``,
        giftconfig: {
          addgift: {
            has: true,
            content: { formid: 0 },
          },
          regift: {
            has: false,
            content: [],
          },
        },
        h_share: true,
        catchconfig: {
          end: null,
          begin: null,
        },
      },

      hasdept: false,
      //显示使用人下拉框
      useuser_sel: false,
      useuser_data: [],
      useuser: {
        datas: [],
        seldatas: [],
        closeModal: function () {},
        loading: false,
      },

      //当前选择时间的是哪个组件 1开始 2结束时间
      vanttime_item: 1,
      //是否显示时间选择组件
      vanttime_show: false,
      minDate: new Date(),
      maxDate: new Date(2025, 10, 1),
      nowDate: new Date(),

      text_show: false,
      text_clone: "",
      text_action: "",
      text_placeholder: "",

      hi_show: false,
      editHtml: "",

      //海报上传界面是否显示
      posterupload_show: false,
      posterupload_result: null,
      posterupload_wait: null,
      posterupload_loading: false,

      //标签相关
      userTabs: {
        seltag: [],
        datas: [],
        confimEvent: function () {},
      },
      userTabs_sel: false,
      //  弹出提醒频率
      showFrequency: false,
      time: {
        // 时间间隔,
        interval: [
          "不提醒",
          "15分钟",
          "30分钟",
          "一个小时",
          "两个小时",
          "一天",
        ],
        // 时间间隔弹出层
        showInterval: false,
        // 时间间隔
        timeInterval: "",
        // 时间段-起
        timeBeginList: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,],
        beginShow: false,
        beginValue: null,
        // 时间段-止
        timeEndList: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,],
        endShow: false,
        endValue: null,
      },
      remindconfig:{
        frequency:0,
        timebegin:8,
        timeend:22
      }
    };
  },
  //监听路由的路径，可以通过不同的路径去选择不同的切换效果
  watch: {
    item: {
      handler(val, oldval) {
        localStorage.setItem("_cg_mcoupon", JSON.stringify(val));
      },
      deep: true,
    },

    useuser: {
      handler(val, oldval) {
        var t = this;
        // var copyitem = JSON.parse(JSON.stringify(t.item));
        t.item.useuser = JSON.stringify(val.seldatas);
        localStorage.setItem("_cg_mcoupon", JSON.stringify(t.item));
      },
      deep: true,
    },

    userTabs: {
      handler(val, oldval) {
        var t = this;
        // var copyitem = JSON.parse(JSON.stringify(t.item));
        t.item.tab_content = JSON.stringify(t.userTabs.seltag);
        localStorage.setItem("_cg_mcoupon", JSON.stringify(t.item));
      },
      deep: true,
    },

    posterupload_result: {
      handler(val, oldval) {
        var t = this;
        t.item.rank_poster = JSON.stringify(t.posterupload_result);
        localStorage.setItem("_cg_mcoupon", JSON.stringify(t.item));
      },
      deep: true,
    },
  },
  methods: {
    logRange(obj) {
      lastEditRange = obj;
    },
    //设置异常信息
    setCatchConfig() {
      this.catchconfig.show = true;
    },
    enterCatchConfig() {
      if (this.checkCatchConfig()) {
        this.catchconfig.show = false;
      }
    },
    checkCatchConfig() {
      var t = this;
      var ret = true;
      do {
        if (!t.item.catchconfig.end.text.content) {
          ret = false;
          Toast("请输入回复的文本内容");
        }
        if (t.item.catchconfig.end.tab == "b") {
          console.log(
            "t.item.catchconfig.end.image.media_path",
            t.item.catchconfig.end.image.media_path
          );
          if (!t.item.catchconfig.end.image.media_path) {
            ret = false;
            Toast("请上传图片内容");
          }
        } else if (t.item.catchconfig.end.tab == "c") {
          if (!t.item.catchconfig.end.link.title) {
            ret = false;
            Toast("请设置链接标题");
          } else if (!t.item.catchconfig.end.link.desc) {
            ret = false;
            Toast("请设置链接描述");
          } else if (!t.item.catchconfig.end.link.picurl) {
            ret = false;
            Toast("请设置链接小图标");
          } else if (!t.item.catchconfig.end.link.url) {
            ret = false;
            Toast("请设置链接地址");
          }
        }
      } while (false);
      return ret;
    },
    //提交数据
    subdata(callback) {
      var t = this;
      var params = JSON.parse(JSON.stringify(t.item));
      //#region 数据合法性验证
      if (!t.useuser.seldatas || t.useuser.seldatas.length <= 0) {
        Toast("请选择添加的企微号");
        return;
      }

      //自动打标签
      if (params.auto_tab) {
        if (!t.userTabs.seltag || t.userTabs.seltag.length <= 0) {
          Toast("请选择标签");
          return;
        }
      }
      //添加企微奖励内容
      if (t.item.giftconfig.addgift.has) {
        if (
          !t.item.giftconfig.addgift.content ||
          t.item.giftconfig.addgift.content.formid <= 0
        ) {
          Toast("请设置添加企微奖励内容");
          return;
        }
      }
      //开启裂变
      if (params.h_share) {
        if (!t.posterupload_result) {
          Toast("请设置裂变海报");
          return;
        }
        if (!params.share_words) {
          Toast("请输入裂变参考话术");
          return;
        }

        var giftconfig = [];
        //奖品设置判断
        for (
          let index = 0;
          index < t.item.giftconfig.regift.content.length;
          index++
        ) {
          const element = t.item.giftconfig.regift.content[index];
          if (!element.name) {
            Toast("请设置裂变奖品名称");
            return;
          }
          if (!element.amount) {
            Toast("请设置裂变奖品数量");
            return;
          }
          if (element.type == 1 && !element.winrank) {
            Toast("请设置裂变获奖排名");
            return;
          }
          if (element.type == 2 && !element.wincount) {
            Toast("请设置裂变获奖达标人数");
            return;
          }
          // if (!element.winnotice) {
          //   Toast("请设置裂变中奖通知内容");
          //   return;
          // }
          if (!element.formid || element.formid <= 0) {
            Toast("请设置奖励内容");
            return;
          }
          if (element.image_vant.length > 0) {
            if (element.image_vant[0].status == "uploading") {
              Toast("领奖图片正在上传，请稍后");
              return;
            }
            if (element.image_vant[0].status == "failed") {
              Toast("领奖图片上传失败，请删除重新上传");
              return;
            }
          }
          console.log("element.image_vant", element.image_vant);
          giftconfig.push({
            name: element.name,
            amount: element.amount,
            type: element.type,
            typename: element.typename,
            wincount: element.wincount,
            winrank: element.winrank,
            winnotice: element.winnotice,
            image:
              element.image_vant.length > 0 ? element.image_vant[0].path : "",
            active: element.active,
            formid: element.formid,
          });
        }

        //#endregion

        //数据处理
        // params.giftconfig = JSON.stringify(giftconfig);
      }

      if (!params.catchconfig.end) {
        Toast("请设置活动结束的回复内容");
        return;
      }
      if (!t.checkCatchConfig()) return;

      // if (!t.errimage_vant || t.errimage_vant.length <= 0) {
      //   Toast("请上传联系人企业微信名片码");
      //   return;
      // }
      // if (
      //   !hi_content.text ||
      //   !hi_content.text.content ||
      //   hi_content.text.content.length <= 0
      // ) {
      //   Toast("请输入回复内容");
      //   return;
      // }
      // params.hi_content = {
      //   text: hi_content.text,
      // };
      params.coupon_id = params.coupon_id || 0;
      params.hi_content.text.content = encodeURIComponent(
        params.hi_content.text.content
      );
      params.useuser = JSON.stringify(t.useuser.seldatas);
      params.auto_firend = true;
      params.auto_sayhi = true;
      //   params.auto_tab = params.auto_tab ? 1 : 0;
      params.tab_content = JSON.stringify(t.userTabs.seltag);
      params.hi_content = JSON.stringify(params.hi_content);
      params.catchconfig = JSON.stringify(params.catchconfig);
      params.giftconfig = JSON.stringify(params.giftconfig);
      // params.rank_poster =  t.posterupload_result[0].path;
      // if(t.posterupload_result!=null && t.posterupload_result!="null")
      params.rank_poster = JSON.stringify(t.posterupload_result);
      // 添加时间参数
      params.remindconfig=JSON.stringify(t.remindconfig)
      console.log("params.rank_poster", params.rank_poster);
      if (!params.rank_poster || params.rank_poster == "null") {
        params.rank_poster = null;
      }
      // params.err_image = t.errimage_vant[0].path;
      params.coupon_title = "好友裂变" + new Date().valueOf();
      params.coupon_type = 2;
      // console.log("提交的数据",params);
      t.loading_sub = true;
      t.$http
        .post("/Coupon/SaveCoupon", params, 2)
        .then((res) => {
          t.loading_sub = false;
          t.item.coupon_id = res.Data;
          if (res.resultState == 1) {
            localStorage.removeItem("_cg_mcoupon");
            if (typeof callback == "function") callback();
            else t.goQrcode(res.Data);
          } else {
            if (res.errorCode == "1001") t.$AskBuy(res.errorMsg);
            else Toast(res.errorMsg);
          }
        })
        .catch((error) => {
          t.loading_sub = false;
          Toast("网络异常，请稍后重试");
        });
    },

    goQrcode(id) {
      var t = this;
      t.GetBindCorp(() => {
        if (t.corpinfo)
          t.$router.replace({
            path: "/mcoupon/info1",
            query: { id: id },
          });
        else this.$router.back(-1);
      });
    },

    //获得当前账号绑定的公众号信息
    GetBindCorp(callback) {
      var t = this;
      var url = `/user/GetBindCorp`;
      var params = {};
      t.corpinfo = null;
      t.$http
        .get(url, params, 2)
        .then((res) => {
          if (res.resultState == 1) {
            t.corpinfo = res.Data;
          } else {
          }
          typeof callback == "function" && callback();
        })
        .catch((error) => {
          console.log(error);
          typeof callback == "function" && callback(error);
        });
    },
    //开始设置分享奖励
    startShareReward() {
      this.reward.shareGift = this.item.giftconfig.regift.content;
      this.reward.shareShow = true;
    },
    //确认设置分享奖励
    enterShareReward() {
      var t = this;
      console.log("t.reward.shareGift", t.reward.shareGift);
      //参数校验
      if (t.reward.shareGift && t.reward.shareGift.length > 0) {
        //奖品设置判断
        for (let index = 0; index < t.reward.shareGift.length; index++) {
          const element = t.reward.shareGift[index];
          if (!element.name) {
            Toast("请设置裂变奖品名称");
            return;
          }
          if (!element.amount) {
            Toast("请设置裂变奖品数量");
            return;
          }
          if (element.type == 1 && !element.winrank) {
            Toast("请设置裂变获奖排名");
            return;
          }
          if (element.type == 2 && !element.wincount) {
            Toast("请设置裂变获奖达标人数");
            return;
          }
          // if (!element.winnotice) {
          //   Toast("请设置裂变中奖通知内容");
          //   return;
          // }
          if (!element.formid || element.formid <= 0) {
            Toast("请设置奖励内容");
            return;
          }
          console.log("element.image_vant", element.image_vant);
          if (element.image_vant.length > 0) {
            if (element.image_vant[0].status == "uploading") {
              Toast("领奖图片正在上传，请稍后");
              return;
            }
            if (element.image_vant[0].status == "failed") {
              Toast("领奖图片上传失败，请删除重新上传");
              return;
            }
          }
        }
      }
      this.item.giftconfig.regift.content = this.reward.shareGift;
      console.log(
        "this.item.giftconfig.regift.content",
        this.item.giftconfig.regift.content
      );
      this.reward.shareShow = false;
    },
    editReward(action) {
      var t = this;
      console.log(
        "****t.item.giftconfig.addgift.content",
        t.item.giftconfig.addgift.content
      );
      if (!t.item.giftconfig.addgift.has) return;
      t.reward.nowitem.action = action;
      switch (action) {
        case "addgift":
          t.reward.nowitem.content = JSON.parse(
            JSON.stringify(t.item.giftconfig.addgift.content)
          );
          t.reward.rewardtype =
            t.item.giftconfig.addgift.content.rewardtype || 1;
          break;
        default:
          break;
      }

      t.reward.SettleShow = true;

      // if (t.reward.nowitem.content && t.reward.nowitem.content.formid){
      //   t.reward.SettleShow = true;
      // }
      // else{
      //    t.reward.rewardTypeShow = true;
      // }

      console.log("t.reward.nowitem.content", t.reward.nowitem.content);
    },
    enterReward() {
      var t = this;
      switch (t.reward.nowitem.action) {
        case "addgift":
          t.item.giftconfig.addgift.content = JSON.parse(
            JSON.stringify(t.reward.nowitem.content)
          );
          break;
        default:
          break;
      }
      console.log(
        " t.item.giftconfig.addgift.content ",
        t.item.giftconfig.addgift.content
      );
      t.reward.SettleShow = false;
    },
    rewardSettleEnter(formid, rewardtype) {
      var t = this;
      switch (t.reward.nowitem.action) {
        case "addgift":
          if (formid) {
            t.reward.nowitem.content.formid = parseInt(formid);
            t.reward.nowitem.content.rewardtype = rewardtype || 1;
            console.log("t.reward.nowitem.content", t.reward.nowitem.content);
            t.item.giftconfig.addgift.content = JSON.parse(
              JSON.stringify(t.reward.nowitem.content)
            );
          }
          break;
        default:
          break;
      }
      t.reward.SettleShow = false;
    },
    onSelectTags() {
      if (this.item.auto_tab == true) this.userTabs_sel = true;
    },
    //打开海报上传的窗体
    poseter_module() {
      if (this.posterupload_result) {
        console.log("has poster info");
        localStorage.setItem(
          "poster.config",
          JSON.stringify(this.posterupload_result)
        );
      } else {
        console.log("no poster info");
        localStorage.removeItem("poster.config");
      }
      this.posterupload_show = true;
    },
    poster_module_enter(res) {
      this.posterupload_result = res;
      this.posterupload_show = false;
    },
    //打开海报上传的窗体
    poseter_go() {
      this.posterupload_wait = this.posterupload_result;
      this.posterupload_show = true;
    },
    //取消上传海报
    poster_cancel() {
      this.posterupload_show = false;
    },
    //确认上传海报
    poster_enter() {
      if (
        this.posterupload_wait &&
        this.posterupload_wait.length > 0 &&
        !this.posterupload_wait[0].status
      ) {
        this.posterupload_result = this.posterupload_wait;
        this.posterupload_show = false;
      } else {
        this.$Toast("还没上传海报哦");
      }
    },

    //添加一个变量
    addval(action) {
      var t = this;
      var editHtml = "";
      switch (action) {
        case "用户昵称":
          // t.editHtml += '<a btype="用户昵称" href="#" class="text">用户昵称</a>';
          editHtml = "用户昵称";
          break;
        case "排行榜链接":
          // t.editHtml += '<a btype="排行榜链接" href="#">影响力排行榜</a>';
          editHtml = "排行榜链接";
          break;
        case "分享文案":
          // t.editHtml += '<a btype="分享文案链接" href="#">参考分享文案</a>';
          editHtml = "分享文案链接";
          break;
        case "兑换奖品":
          // t.editHtml += '<a btype="兑换奖品链接" href="#">兑换奖品</a>';
          editHtml = "新添加好友奖励领取链接";
        default:
          editHtml = action;
          break;
      }
      setTimeout(() => {
        editHtml = keepLastIndex(
          document.getElementById("diveditable"),
          editHtml
        );
        t.editHtml = editHtml;
      }, 5);
    },
    showHiEdit() {
      this.editHtml = this.item.hi_content.text.content;
      this.hi_show = true;
    },
    //确认设置欢迎语
    hiShowEnter() {
      this.item.hi_content.text.content = this.editHtml;
      this.hi_show = false;
    },
    blurHighLight() {
      // 这里做数据过滤或样式变更操作
    },
    handleInput($event) {
      console.log("$event", $event.target);
      //this.content = $event.target.innerText;
      // 拓展 如果想要只需要前100位数据
    },
    textEvent(action) {
      var t = this;
      t.text_show = true;
      t.text_action = action;
      switch (action) {
        case "rule":
          t.text_placeholder = "请输入活动规则";
          t.text_clone = t.item.giftrule;
          break;
        case "share":
          t.text_placeholder = "请输入参考话术";
          t.text_clone = t.item.share_words;
          break;
        default:
          break;
      }
    },
    //确认设置为活动规则
    logicFieldEnter() {
      var t = this;
      t.text_show = false;
      switch (t.text_action) {
        case "rule":
          t.item.giftrule = t.text_clone;
          break;
        case "share":
          t.item.share_words = t.text_clone;
          break;
        default:
          break;
      }
    },
    //选择时间
    seltime(type) {
      this.vanttime_item = type;
      this.vanttime_show = true;
      if (this.vanttime_item == 1) {
        this.nowDate = new Date(this.item.coupon_begindate);
      } else if (this.vanttime_item == 2) {
        this.nowDate = new Date(this.item.coupon_expdate);
      }
    },

    vanttime_confirm(value) {
      console.log("value", value);
      var t = this;
      if (t.vanttime_item == 1) {
        this.item.coupon_begindate = t.dateformat(
          "Y-m-d H:i:s",
          value.valueOf()
        );
      } else if (t.vanttime_item == 2) {
        this.item.coupon_expdate = t.dateformat("Y-m-d H:i:s", value.valueOf());
      }
      this.vanttime_show = false;
    },
    vanttime_cancel() {
      this.vanttime_show = false;
    },

    //点击选择使用人
    seluseuserEvent() {
      if (!this.useuser.loading) return;
      this.useuser_sel = true;
      this.useuser.isdefault = this.isdefault;
    },
    //确认选择使用人
    useuser_sel_confirm(value) {
      var t = this;
      t.useuser_sel = false;
      t.item.useuser = value;
    },
    //获得企业外部联系人所有标签
    GetAllClientTags() {
      var t = this;
      t.$http
        .get("/Channel/GetAllClientTags", {}, 2)
        .then((res) => {
          var usertabs = [];
          if (res.resultState == 1) {
            usertabs = res.Data;
          }
          t.userTabs.datas = usertabs;
        })
        .catch((error) => {});
    },

    //获得部门下的所有部门
    getDeptObj(deptid) {
      var t = this;
      deptid = deptid || 1;
      this.$http
        .get("/Firm/GetDeptObj", { deptid: deptid || 1 }, 2)
        .then((res) => {
          if (res.resultState == 1) {
            t.hasdept = true;
          }
        })
        .catch((error) => {});
    },
    //获得拥有外部联系权限的用户信息
    GetFollowUserList() {
      var t = this;
      var useuser_data = [];
      this.$http
        .get("/Channel/GetFollowUserInfoList", {}, 2)
        .then((res) => {
          t.useuser.loading = true;
          if (res.resultState == 1) {
            // useuser_data = useuser_data.concat(res.Data);
            // t.useuser_data = useuser_data;
            t.useuser.datas = res.Data;
          }
        })
        .catch((error) => {});
    },

    getdetail(id) {
      var t = this;
      this.$http
        .get("/Coupon/GetCouponDetail", { couponid: id }, 2)
        .then((res) => {
          // console.log("返回的数据",res);
          t.firstloading = true;
          if (res.resultState == 1) {
            var has_img = 1;
            var has_link = 1;
            var item = res.Data;
            item.hi_content = JSON.parse(item.hi_content);
            if (!item.hi_content.text) item.hi_content.text = { content: "" };
            if (!item.hi_content.image) {
              has_img = 0;
              item.hi_content.image = {
                media_path: "",
              };
            }
            if (!item.hi_content.link) {
              has_link = 0;
              item.hi_content.link = {
                title: "",
                picurl: "",
                desc: "",
                url: "",
                default: 1,
              };
            }
            t.hi_content_tab = "a";
            if (has_img == 1) {
              t.hi_content_tab = "b";
              t.image_vant = [
                {
                  url: `${config.img_host}${item.hi_content.image.media_path}`,
                  status: "",
                  message: "",
                  path: item.hi_content.image.media_path,
                },
              ];
            }
            if (has_link == 1) {
              t.hi_content_tab = "c";
              t.link_vant = [
                {
                  url: `${config.img_host}${item.hi_content.link.picurl}`,
                  status: "",
                  message: "",
                  path: item.hi_content.link.picurl,
                },
              ];
            }
            item.tab_content = JSON.parse(item.tab_content);
            item.catchconfig = JSON.parse(
              item.catchconfig || '{"end":null, "begin":null}'
            );
            t.useuser.seldatas = JSON.parse(item.useuser || "[]");
            t.userTabs.seltag = item.tab_content;

            t.posterupload_result = [
              {
                url: `${config.img_host}${item.rank_poster}`,
                status: "",
                message: "",
                path: item.rank_poster,
              },
            ];
            try {
              t.posterupload_result = JSON.parse(item.rank_poster);
            } catch {
              t.posterupload_result = null;
            }

            console.log("t.posterupload_result", t.posterupload_result);
            t.errimage_vant = [
              {
                url: `${config.img_host}${item.err_image}`,
                status: "",
                message: "",
                path: item.err_image,
              },
            ];

            var giftlist = JSON.parse(item.giftconfig || "{}");
            item.giftconfig = JSON.parse(item.giftconfig || "{}");
            for (let index = 0; index < giftlist.length; index++) {
              var type = t.gifttype_actions.find(
                (x) => x.id == giftlist[index].type
              );
              giftlist[index].typename = type ? type.name : "";
              giftlist[index].image_vant = [];
              if (giftlist[index].image) {
                giftlist[index].image_vant = [
                  {
                    url: `${config.img_host}${giftlist[index].image}`,
                    status: "",
                    message: "",
                    path: giftlist[index].image,
                  },
                ];
              }
            }
            t.giftlist = giftlist;
            t.item = item;
          }
          // t.remindconfig=JSON.parse(res.Data.remindconfig)
         if( res.Data.remindconfig ==null){
              t.remindconfig.frequency=2;
              t.remindconfig.timebegin=9;
              t.remindconfig.timeend=19;
         }else{
           t.remindconfig=JSON.parse(res.Data.remindconfig)
         }
        })
        .catch((error) => {
          console.log("error", error);
          t.firstloading = true;
        });
    },

    frequencyClick() {
      this.showFrequency = true;
    },

    // 时间间隔确认事件
    timeConfim(value, index) {
      this.time.timeInterval = value;
      this.time.showInterval = false;
      this.remindconfig.frequency = index;
    },
    // 时间间隔取消时间
    timeCancel() {
      this.time.showInterval = false;
    },
    // 起止时间-起
    beginConfim(value) {
      this.remindconfig.timebegin = value;
      this.time.beginShow = false;
    },
    endConfim(value) {
      this.remindconfig.timeend = value;
      this.time.endShow = false;
    },

    // 时间确认
    timeClick() {
      if(this.remindconfig.frequency==null){
        Toast.fail("请选择时间间隔");
        return
      }
      if(this.remindconfig.timebegin==null|| this.remindconfig.timeend==null){
        Toast.fail("请选择时间段");
        return
      }
      let a=JSON.stringify(this.remindconfig)
      console.log(a);
      this.showFrequency = false;
    },
  },
  components: {
    wx_usersn,
    wx_users,
    div_editable,
    wx_poster,
    Swiper,
    SwiperSlide,
    wx_tags,
    lu_rewardsettle,
    lu_rewardsettleadd,
    lu_formedit,
    lu_rewardtype,
    lu_qwautohi,
  },
  directives: {
    swiper: directive,
  },
  created() {
    var t = this;
    console.log("t.$route.query", t.$route.query);
    if (t.$route.query.couponid) t.getdetail(t.$route.query.couponid);
    else {
      var _cg_mcoupon = localStorage.getItem("_cg_mcoupon");
      if (_cg_mcoupon) {
        Dialog.confirm({
          title: "系统提示",
          message: "您还有一条草稿尚未保存，要继续编辑吗？",
          confirmButtonText: "继续去编辑",
          cancelButtonText: "丢弃这个草稿",
        })
          .then(() => {
            t.item = JSON.parse(_cg_mcoupon);
            t.useuser.seldatas = JSON.parse(t.item.useuser || "[]");
            t.userTabs.seltag = JSON.parse(t.item.tab_content);
            t.posterupload_result = JSON.parse(t.item.rank_poster);
          })
          .catch(() => {
            localStorage.removeItem("_cg_mcoupon");
          });
      }
      t.firstloading = true;
    }
    t.getDeptObj(0);
    t.reward.editcc.close = function (formid, rewardtype) {
      console.log("formid", formid);
      t.reward.SettleShow = false;
      t.rewardSettleEnter(formid, rewardtype);
    };
    t.reward.typecc.close = function (type) {
      t.reward.nowitem.content.formid = 0;
      t.reward.rewardtype = type;
      t.reward.SettleShow = true;
      t.reward.rewardTypeShow = false;
    };
    t.$http
      .get("/Firm/GetConfig", {}, 2)
      .then((res) => {
        if (res.resultState == 1) {
          if (!res.Data.Secret) {
            Dialog.confirm({
              title: "系统提示",
              message: "未进行开发配置，需要先配置才能正常创建渠道哦~",
              confirmButtonText: "现在去设置",
              cancelButtonText: "一会再去",
            })
              .then(() => {
                console.log("confirm success");
                window.location.href = "./#/?page=corsettle";
              })
              .catch(() => {
                t.GetFollowUserList();
                t.GetAllClientTags();
              });
          } else {
            t.GetFollowUserList();
            t.GetAllClientTags();
          }
        } else {
          Toast(res.errorMsg);
          setTimeout(() => {
            t.$router.back(-1);
          }, 2000);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });

    t.userTabs.confimEvent = function () {
      t.userTabs_sel = false;
    };
    t.useuser.closeModal = function () {
      t.useuser_sel = false;
    };
  },
  computed: {
    item_share_words() {
      var t = this;
      var ret = t.item.share_words || "";
      ret = ret.replace(/<.*?>/g, "");
      if (ret.length > 10) ret = ret.substring(0, 10) + "...";
      return ret;
    },
    item_giftrule() {
      var t = this;
      var ret = t.item.giftrule || "";
      ret = ret.replace(/<.*?>/g, "");
      if (ret.length > 10) ret = ret.substring(0, 10) + "...";
      return ret;
    },
    hi_content_text() {
      var t = this;
      var ret = t.item.hi_content.text.content || "";
      ret = ret.replace(/<.*?>/g, "");
      if (ret.length > 10) ret = ret.substring(0, 10) + "...";
      return ret;
    },
    getTabName() {
      var t = this;
      var ret = [];
      for (let i = 0; i < t.userTabs.seltag.length; i++) {
        for (let j = 0; j < t.userTabs.datas.length; j++) {
          for (let s = 0; s < t.userTabs.datas[j].tag.length; s++) {
            if (t.userTabs.datas[j].tag[s].id == t.userTabs.seltag[i]) {
              console.log("ret", ret);
              ret.push(`${t.userTabs.datas[j].tag[s].name}`);
              break;
            }
          }
        }
        // if (i < t.userTabs.seltag.length - 1) ret += "，";
      }
      return ret;
    },
    getUserName() {
      var t = this;
      var ret = [];
      if (t.useuser.seldatas) {
        for (let i = 0; i < t.useuser.seldatas.length; i++) {
          var userinfo = t.useuser.datas.find(
            (item) => item.userid == t.useuser.seldatas[i]
          );
          console.log("userinfo", userinfo);
          if (userinfo) ret.push(userinfo.name);
          // if (i < t.useuser.seldatas.length - 1) ret += "，";
        }
      }
      return ret;
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import "../../../static/scss/var";

.form-region {
  margin-bottom: vw(25);
  padding: vw(20) vw(25);
  background-color: #fff;
  .form-region-title {
    font-weight: bold;
    font-size: 20px;
    color: #000;
    padding: 10px 0;
    @include flex;
    @include align_items_center;
    span {
      @include flex_1;
    }
    .van-switch {
    }
  }
  .pointer {
    cursor: pointer;
    input {
      cursor: pointer;
    }
  }
  .form-region-row {
    @include flex;
    @include align_items_center;
    height: 60px;
    font-size: 15px;
    border-bottom: 1px #efefef solid;
    color: $vm_fontcolor_main;
    .title {
    }
    .input {
      @include flex_1;
      border: 0;
      text-align: right;
      margin-left: 10px;
      border-radius: 3px;
      font-size: 14px;
    }
    .tags {
      width: 0;
      @include flex;
      .lqizi {
        @include flex_1;
      }
    }
    div.input {
      color: #999;
      // text-align: right;
      font-size: 14px;
      .tag {
        font-size: 12px;
        background-color: $vm_bg_main;
        color: #fff;
        margin-right: 5px;
        border-radius: 3px;
        height: 24px;
        line-height: 24px;
        padding: 0 10px;
      }
      .more {
        padding: 3px 10px;
        margin-right: 5px;
        border-radius: 3px;
        font-size: 12px;
        background-color: #fff;
        color: #212121;
        border: 1px solid #ccc;
      }

      .swiper-container {
        // overflow: inherit;
      }
    }
    .van-icon,
    .van-switch {
      font-size: vw(24);
      margin-left: vw(10);
    }
  }
}
.form-bottom {
  height: 70px;
}

.form-tool {
  z-index: 999;
  background-color: #fff;
  padding: vw(20);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  border-top: 1px solid #efefef;
}

.logic-field-head {
  padding: 0 15px;
  line-height: 55px;
  overflow: hidden;
  border-bottom: 1px solid #efefef;
  position: relative;
  z-index: 1;
  .fleft {
    color: $vm_fontcolor_minor2;
    float: left;
  }
  .fright {
    color: $vm_bg_main;
    float: right;
  }
}
.logic-field-content-auto {
  overflow-y: auto;

  height: calc(100% - 56px);
  box-sizing: border-box;
  position: static;
  z-index: 0;
}
.logic-field-content {
  padding: 20px;
  .edit-contain {
    padding: 10px;
    min-height: 300px;
    border: 1px solid #efefef;
    box-sizing: border-box;
  }

  .edit-var {
    span {
      font-size: 12px;
      color: #fff;
      margin-right: 5px;
      cursor: pointer;
      line-height: 28px;
      background-color: $vm_bg_main;
      padding: 3px 6px;
      border-radius: 3px;
    }
    span::before {
      content: "#";
    }
    span::after {
      content: "#";
    }
  }
}

.swiper-slide {
  display: inline-block;
  width: auto;
}
</style>
